module.exports = __webpack_public_path__ + "static/media/Teacher_Icon.e534a956.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Teacher_Icon.svg
// module id = 96
// module chunks = 0